import { useState, useEffect } from "react";
const delay = 200;
function useWindowWidth() {
    const [width, setWidth] = useState(() => window.innerWidth);
    useEffect(() => {
        let timeoutId;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setWidth(window.innerWidth);
            }, delay);
        };
        window.addEventListener("resize", handleResize);
        // Set initial width
        handleResize();
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", handleResize);
        };
    }, [delay]);
    return width;
}
export default useWindowWidth;
